// extracted by mini-css-extract-plugin
module.exports = {"initialize":"_6e18be0"};